(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/lobby/info-overlay.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/lobby/info-overlay.js');
"use strict";

const {
  GAME_URL,
  LOADING_INFO_IMAGES
} = svs.eInstant.lobby.actions;
const InfoOverlay = () => {
  const {
    useEffect,
    useContext,
    useCallback,
    useMemo,
    useState,
    useRef
  } = React;
  const {
    state,
    dispatch
  } = useContext(svs.eInstant.lobby.LobbyContext);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const mountedRef = useRef(false);
  const {
    hideFooter,
    showFooter,
    createAnimationTimeline
  } = svs.eInstant.util;
  const {
    InfoProvider,
    Info
  } = svs.eInstant.shared.info;
  const onImagesLoaded = useCallback(() => {
    if (!mountedRef.current) {
      return;
    }
    setImagesLoaded(true);
    dispatch({
      type: LOADING_INFO_IMAGES,
      payload: false
    });
  }, [dispatch]);
  const onHideAnimationDone = useCallback(() => {
    if (!mountedRef.current) {
      return;
    }
    dispatch({
      type: GAME_URL,
      payload: {
        gameUrl: null
      }
    });
  }, [dispatch]);
  const {
    showInfo,
    hideInfo,
    kill
  } = useMemo(() => createAnimationTimeline(onImagesLoaded, onHideAnimationDone, state.gameUrl), [onImagesLoaded, onHideAnimationDone, state.gameUrl]);
  const onClose = useCallback(e => {
    e === null || e === void 0 || e.preventDefault();
    window.history.replaceState(null, '', "".concat(svs.core.data.baseUrl));
    document.title = 'Spela E-instant online | Svenska Spel';
    hideInfo();
  }, [hideInfo]);
  useEffect(() => {
    hideFooter();
    dispatch({
      type: LOADING_INFO_IMAGES,
      payload: true
    });
    showInfo();
    return () => {
      showFooter();
    };
  }, [dispatch, state.gameUrl]);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      kill();
    };
  }, [kill]);
  return React.createElement(InfoProvider, {
    gameUrl: state.gameUrl
  }, React.createElement(Info, {
    onClose: onClose,
    show: imagesLoaded
  }));
};
setGlobal('svs.eInstant.lobby.InfoOverlay', InfoOverlay);

 })(window);